import { BookingProvider } from '../contexts/BookingContext';
import { useData } from '../hooks/useData';
import BookingRouter from './BookingRouter';

interface BookingProps {
	completeTask?: () => void;
	dataUrl: string;
	onExit?: () => void;
	setSceneDataById?: (id: number) => void;
}

export default function Booking({ completeTask = () => {}, dataUrl, onExit, setSceneDataById = () => {} }: BookingProps) {
	const { data, error, isLoadingAppData } = useData(dataUrl);

	function getLabel(key: string) {
		return data?.labels[key] || '';
	}

	if (isLoadingAppData || error || !data) {
		return null;
	}

	return (
		<BookingProvider completeTask={completeTask} data={data} setSceneDataById={setSceneDataById} testProp="testProp">
			<BookingRouter getLabel={getLabel} onExit={onExit} />
		</BookingProvider>
	);
}
